import { OrganizationKeyName } from "../../model/Organization";
import { RootState } from "../../store";

export const adminUserList = (state: RootState, org: OrganizationKeyName) => {
  return state.adminUser.list[org] || [];
};

export const isLoadingAdminUserList = (
  state: RootState,
  org: OrganizationKeyName
): boolean => {
  return state.adminUser.isLoadingList[org] || false;
};

export const isLoadingUser = (
  state: RootState,
  org: OrganizationKeyName
): boolean => {
  return state.adminUser.isLoadingUser[org] || false;
};

export const user = (state: RootState, org: OrganizationKeyName): any => {
  return state.adminUser.user[org];
};

export const isUpserting = (state: RootState): boolean => {
  return state.adminUser.isUpserting;
};

export const upsertErrors = (
  state: RootState
): { [field: string]: string } | null => {
  const errors = state.adminUser.upsertErrors;

  if (!errors || errors.length === 0) {
    return null;
  }

  return errors.reduce((p, c) => {
    p[c.title] = c.detail;
    return p;
  }, {});
};
